import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ErrorcontrolService } from 'basecomponents';
import { MessageError } from 'base-models';
import { PanelTypeSelectListComponent } from '@solar/solar/panel/paneltype-select-list/paneltype-select-list.component';
import { PanelType, Site, UploadTypeEnum } from 'solar-bo';
import { UploadInfo, UploadService } from 'guploadmgr';
import { FileUploaderOptions } from 'projects/guploadmgr/src/lib/uploadfiles/file-uploader.class';
import { AppConfig } from '@solar/app.config';
import { SolarBaseComponent } from '@solar/solar/solar-base';




@Component({
  selector: 'app-panel-layer-add',
  templateUrl: './panel-layer-add.component.html',
  styleUrls: ['./panel-layer-add.component.scss']
})
export class PanelLayerAddComponent extends SolarBaseComponent implements OnInit {
  /**
   * name to identify the class
   */
  TAG: string = "OlLayerAddComponent";
  title: string = "Add layer";
  titlesub: string = "";
  public dialogRef: MatDialogRef<any>;

  hasBaseDropZoneOver: boolean = false;
  geojson: any = "";
  layerName: string = "";
  layerId: string = "";
  layerNameEditable: boolean = true;
  myform: FormGroup;
  alertmessage: MessageError | string;
  acceptFilter="";//".geojson ,text/plain";
  site:Site;

  constructor(
    private uploadService: UploadService,
    private fb:FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    //data is mandatory
    this.site = data.site;
      if (data.layerName) {
        this.layerName = data.layerName;
      }
      if (data.layerId) {
        this.layerId = data.layerId;
      }
      if (data.layerNameEditable !== null) {
        this.layerNameEditable = data.layerNameEditable;
      }    

      if (data.title) {
        this.title = data.title;
      }
      
      if (data.titlesub) {
        this.titlesub = data.titlesub;
      }
    
    this.createForm();
    this.loadinglist=false;
  }

  ngOnInit() {
  }
  showerror(message: string, err?: any) {
    this.alertmessage = ErrorcontrolService.basichandleError(message, err, null, this.TAG);
  }

  isvalid() {
    if (this.fileSelected == null) {
      return false;
    }
    if (this.submitted){
      return false;
    }
    return true;
  }

  okaction() {
    if (this.fileSelected == null) {
      this.showerror("Please select a valid file with geodata.")
      return;
    }
    const formModel = this.myform.value;
    let res: any;

    //let geojson: string = this.fileContents;//(formModel.geom)
    let panelType_id= formModel.panelType_id;

    if (this.layerNameEditable) {
      res = { name: formModel.name, layerId: this.layerId  , file:this.fileSelected , panelType_id:panelType_id};
    }
    else {
      res = { name: this.layerName, layerId: this.layerId , file:this.fileSelected, panelType_id:panelType_id };
    }

    this.uploadPanelFile();
    //this.dialogRef.close(res);
  }

  public static openModal(dialog: MatDialog, dialogData?: any): MatDialogRef<PanelLayerAddComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "700px";
    dialogConfig.data = dialogData;

    let dialogRef: MatDialogRef<PanelLayerAddComponent>;
    dialogRef = dialog.open(PanelLayerAddComponent, dialogConfig);
    //dialogRef.componentInstance.dialogRef = dialogRef;
    return dialogRef;
  }

  createForm() {
 /*   let fcname: any;
     if (this.layerNameEditable) {
      fcname = new FormControl({ value: this.layerName }, [Validators.required, Validators.minLength(3)]);
    }
    else {
      fcname = new FormControl({ value: this.layerName, disabled: true });
    } */


    this.myform = this.fb.group({
      name: [this.layerName, [Validators.required, Validators.minLength(3)]],
      panelType_id: [''],
      panelType_name: [''],   
    });

  }
  fileMessage: string = "Choose file with GeoData";
  fileSelected:any;
  fileSelectedEventHandler($event) {
    try {
      //console.log("fileChangeEvent", event);
      let files = $event;//.target.files;
      let msg: string = "";
      for (let f of files) {
        msg += f.name;
        console.log("File selected", f);
        this.fileSelected=f;        
        //this.readFileContents(f);
        break;//only one
      }
      this.fileMessage = msg;
    }
    catch (err) {
      this.showerror("Error ocurred with file selected. ", err);
    }

  }

  fileContents: any;
  private readFileContents(file: any) {
    let reader = new FileReader();
    this.fileContents = null;
    reader.onload = this.handleFileLoad.bind(this);
    reader.readAsArrayBuffer(file);

  }

  handleFileLoad(event) {
    this.fileContents = event.target.result;
  }

  selectPanelType() {
    let dialogRef = PanelTypeSelectListComponent.openDialog(this.dialog);
    let self = this;
    setTimeout(() => {
      dialogRef.componentInstance.panelTypeSelectedEvent.subscribe(elem => {
        self.panelTypeSelected(elem);
        dialogRef.close();
      })
    }, 50);
  }

  panelTypeSelected(elem: PanelType) {
    let panelType = new PanelType();
    Object.assign(panelType, elem);
    console.log("panelTypeSelected", elem);
    const formModel = this.myform;
    formModel.controls.panelType_id.setValue(panelType.id);
    formModel.controls.panelType_name.setValue(panelType.model);
  }

  private uploadPanelFile() {
    //save to server    
    this.submitted = true;
    this.loading = true;
    this.alertmessage = null;
    try {

/*       let uploadinfo: UploadInfo = new UploadInfo();
      uploadinfo.parentid = this.site.id;
      uploadinfo.parentname = this.site.name;
      uploadinfo.id = this.site.id;
      uploadinfo.upload_type = UploadTypeEnum.site_info;
      //

      let uploadOptions: FileUploaderOptions = {};
      uploadOptions.url = `${AppConfig.API_ENDPOINT}/sites/${this.site.id}/panels`;;
      uploadOptions.autoUpload = false;
      uploadOptions.filters = [];
      uploadOptions.removeAfterUpload = false;

      this.uploadService.uploader.addToQueue([this.fileSelected],uploadOptions); */
      //return;
      const formData = new FormData();
      formData.append("file", this.fileSelected);
      const formModel = this.myform;
      let id_panel_type=formModel.controls.panelType_id.value;
      if (id_panel_type!=''){
        formData.append("id_panel_type",  id_panel_type);
      }
      
      this.solarService.siteUploadPanels(this.site.id, formData)
        .subscribe((res) => this.uploadPanelsHandleresult(res), err => this.savehandleError(err)
        );

    } catch (error) {
      this.submitted = false;
      this.loading = false;
      this.showerror(error);
      console.log(error);
    }
  }

  private uploadPanelsHandleresult(resultmodel: any) {
    console.log("site panels saved", resultmodel);
    this.submitted = false;
    this.loading = false;
    let msg=`Your request has been sent to the processing queue.<br>Panels to add: ${resultmodel.add} <br>Panels to modify: ${resultmodel.modify} <br>Panels with error: ${resultmodel.error} `;
    this.showmessage(msg);
    //TODO: ok, se ha guardado, que hacemos con la capa, la borramos y el sistema mostrará la capa?

  }

  private savehandleError<T>(err: any) {
    this.submitted = false;
    this.loading = false;
    this.handleError(err);
  }

}
